(function () {
  'use strict';
  var d = document;
  function $(s, c) { return (c || d).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || d).querySelectorAll(s)); }
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var finePointer = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  function ready(fn) { d.readyState !== 'loading' ? fn() : d.addEventListener('DOMContentLoaded', fn); }

  /* ---------- sticky header, progress bar, back to top ---------- */
  function scrollFx() {
    var header = $('[data-header]'), bar = $('[data-progress]'), top = $('[data-totop]');
    var ticking = false;
    function update() {
      var y = window.pageYOffset || d.documentElement.scrollTop;
      var max = d.documentElement.scrollHeight - window.innerHeight;
      if (header) header.classList.toggle('scrolled', y > 40);
      if (bar) bar.style.width = (max > 0 ? (y / max) * 100 : 0) + '%';
      if (top) top.classList.toggle('show', y > 700);
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });
    update();
    if (top) top.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' }); });
  }

  /* ---------- mobile drawer ---------- */
  function drawer() {
    var dr = $('[data-drawer]');
    if (!dr) return;
    var openers = $$('[data-drawer-open]');
    function open() {
      dr.classList.add('open'); dr.setAttribute('aria-hidden', 'false');
      d.body.classList.add('lock');
      openers.forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
      var first = $('a', dr); if (first) first.focus();
    }
    function close() {
      dr.classList.remove('open'); dr.setAttribute('aria-hidden', 'true');
      d.body.classList.remove('lock');
      openers.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    }
    openers.forEach(function (b) { b.addEventListener('click', open); });
    $$('[data-drawer-close]', dr).forEach(function (b) { b.addEventListener('click', close); });
    $$('a', dr).forEach(function (a) { a.addEventListener('click', close); });
    d.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    window.addEventListener('resize', function () { if (window.innerWidth > 900) close(); });
  }

  /* ---------- reveal on scroll ---------- */
  function reveal() {
    var els = $$('.reveal');
    if (!els.length) return;
    if (!('IntersectionObserver' in window) || reduce) { els.forEach(function (e) { e.classList.add('in'); }); return; }
    els.forEach(function (el) {
      var sibs = $$('.reveal', el.parentNode);
      el.style.transitionDelay = (Math.max(0, sibs.indexOf(el)) % 6) * 90 + 'ms';
    });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- hero slider + rotating words ---------- */
  function hero() {
    $$('[data-hero]').forEach(function (h) {
      var slides = $$('.slide', h), dotsBox = $('.dots', h), i = 0, timer, dots = [];
      function go(n) {
        slides[i].classList.remove('active'); if (dots[i]) dots[i].classList.remove('on');
        i = (n + slides.length) % slides.length;
        slides[i].classList.add('active'); if (dots[i]) dots[i].classList.add('on');
      }
      function play() { stop(); if (!reduce && slides.length > 1) timer = setInterval(function () { go(i + 1); }, 6500); }
      function stop() { clearInterval(timer); }
      if (slides.length > 1 && dotsBox) {
        slides.forEach(function (s, n) {
          var b = d.createElement('button'); b.type = 'button'; b.setAttribute('aria-label', 'Slide ' + (n + 1));
          if (n === 0) b.className = 'on';
          b.addEventListener('click', function () { go(n); play(); });
          dotsBox.appendChild(b); dots.push(b);
        });
      }
      var prev = $('.prev', h), next = $('.next', h);
      if (prev) prev.addEventListener('click', function () { go(i - 1); play(); });
      if (next) next.addEventListener('click', function () { go(i + 1); play(); });
      var sx = null;
      h.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
      h.addEventListener('touchend', function (e) {
        if (sx === null) return;
        var dx = e.changedTouches[0].clientX - sx;
        if (Math.abs(dx) > 50) { go(dx < 0 ? i + 1 : i - 1); play(); }
        sx = null;
      }, { passive: true });
      h.addEventListener('mouseenter', stop); h.addEventListener('mouseleave', play);
      d.addEventListener('visibilitychange', function () { d.hidden ? stop() : play(); });
      play();

      var rot = $('.rotator', h);
      if (rot && !reduce) {
        var words = (rot.getAttribute('data-words') || '').split(',').map(function (w) { return w.trim(); }).filter(Boolean), w = 0;
        if (words.length > 1) {
          setInterval(function () {
            rot.classList.add('out');
            setTimeout(function () { w = (w + 1) % words.length; rot.textContent = words[w]; rot.classList.remove('out'); }, 350);
          }, 2400);
        }
      }
    });
  }

  /* ---------- 3D tilt on cards (mouse only) ---------- */
  function tilt() {
    if (!finePointer || reduce) return;
    $$('[data-tilt]').forEach(function (c) {
      c.addEventListener('pointermove', function (e) {
        var r = c.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5;
        c.style.setProperty('--ry', (x * 8).toFixed(2) + 'deg');
        c.style.setProperty('--rx', (-y * 8).toFixed(2) + 'deg');
      });
      c.addEventListener('pointerleave', function () { c.style.setProperty('--rx', '0deg'); c.style.setProperty('--ry', '0deg'); });
    });
  }

  /* ---------- gallery filter + lightbox ---------- */
  function gallery() {
    var lb, lbImg, lbCap, list = [], idx = 0;
    function build() {
      if (lb) return;
      lb = d.createElement('div'); lb.className = 'lightbox'; lb.setAttribute('role', 'dialog'); lb.setAttribute('aria-modal', 'true');
      lb.innerHTML = '<button class="lb-close" aria-label="Close">&times;</button><button class="lb-prev" aria-label="Previous">&#8249;</button><img alt=""><button class="lb-next" aria-label="Next">&#8250;</button><div class="lb-cap"></div>';
      d.body.appendChild(lb);
      lbImg = $('img', lb); lbCap = $('.lb-cap', lb);
      $('.lb-close', lb).addEventListener('click', close);
      $('.lb-prev', lb).addEventListener('click', function () { show(idx - 1); });
      $('.lb-next', lb).addEventListener('click', function () { show(idx + 1); });
      lb.addEventListener('click', function (e) { if (e.target === lb) close(); });
      var sx = null;
      lb.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
      lb.addEventListener('touchend', function (e) {
        if (sx === null) return; var dx = e.changedTouches[0].clientX - sx;
        if (Math.abs(dx) > 50) show(dx < 0 ? idx + 1 : idx - 1); sx = null;
      }, { passive: true });
      d.addEventListener('keydown', function (e) {
        if (!lb.classList.contains('open')) return;
        if (e.key === 'Escape') close();
        if (e.key === 'ArrowLeft') show(idx - 1);
        if (e.key === 'ArrowRight') show(idx + 1);
      });
    }
    function show(n) {
      idx = (n + list.length) % list.length;
      lbImg.src = list[idx].getAttribute('data-full');
      lbCap.textContent = list[idx].getAttribute('data-caption') || '';
    }
    function open(items, n) { build(); list = items; lb.classList.add('open'); d.body.classList.add('lock'); show(n); }
    function close() { lb.classList.remove('open'); d.body.classList.remove('lock'); }

    $$('[data-gallery]').forEach(function (g) {
      var items = $$('[data-cat]', g);
      $$('[data-filter]', g).forEach(function (b) {
        b.addEventListener('click', function () {
          var f = b.getAttribute('data-filter');
          $$('[data-filter]', g).forEach(function (x) { x.classList.toggle('on', x === b); x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
          items.forEach(function (it) { it.hidden = !(f === 'all' || it.getAttribute('data-cat') === f); });
        });
      });
      items.forEach(function (it) {
        it.addEventListener('click', function () {
          if (!it.getAttribute('data-full')) return;
          var visible = items.filter(function (x) { return !x.hidden && x.getAttribute('data-full'); });
          open(visible, visible.indexOf(it));
        });
      });
    });
  }

  /* ---------- before / after slider ---------- */
  function beforeAfter() {
    $$('[data-ba]').forEach(function (b) {
      var r = $('input[type=range]', b);
      if (!r) return;
      function set() { b.style.setProperty('--pos', r.value + '%'); }
      r.addEventListener('input', set); set();
    });
  }

  /* ---------- permanent lights demo ---------- */
  function lights() {
    $$('[data-lights]').forEach(function (box) {
      var svg = $('svg', box), layer = $('.bulbs', box), paths = $$('.track', box);
      var NS = 'http://www.w3.org/2000/svg', bulbs = [];
      var modes = {
        warm: ['#ffd98a'],
        multi: ['#ff4d4d', '#ffb84d', '#4dff88', '#4da6ff', '#d84dff'],
        holiday: ['#ff3b3b', '#2ecc71'],
        cool: ['#cfeaff', '#7cc4ff'],
        spooky: ['#ff8a1f', '#a54dff']
      };
      var k = 0;
      paths.forEach(function (p) {
        var len = p.getTotalLength(), n = Math.round(len / 24);
        for (var j = 0; j <= n; j++) {
          var pt = p.getPointAtLength(len * j / n);
          var c = d.createElementNS(NS, 'circle');
          c.setAttribute('cx', pt.x.toFixed(1)); c.setAttribute('cy', (pt.y + 5).toFixed(1)); c.setAttribute('r', 4.5);
          c.setAttribute('class', 'bulb');
          c.style.animationDelay = (Math.random() * 2).toFixed(2) + 's';
          layer.appendChild(c); bulbs.push(c); k++;
        }
      });
      function paint(mode) {
        var cols = modes[mode] || modes.warm;
        bulbs.forEach(function (b, i) { b.style.setProperty('--c', cols[i % cols.length]); });
      }
      paint('warm');
      var stage = $('.stage', box), toggle = $('[data-lights-toggle]', box);
      toggle.addEventListener('click', function () {
        var on = stage.classList.toggle('on');
        toggle.setAttribute('aria-pressed', on ? 'true' : 'false');
        toggle.textContent = on ? '💡 Turn off the lights' : '💡 Turn on the lights';
      });
      $$('[data-mode]', box).forEach(function (b) {
        b.addEventListener('click', function () {
          $$('[data-mode]', box).forEach(function (x) { x.classList.toggle('on', x === b); });
          paint(b.getAttribute('data-mode'));
          if (!stage.classList.contains('on')) toggle.click();
        });
      });
    });
  }

  /* ---------- quote form: preselect service, loading state ---------- */
  function contact() {
    function pick(name) {
      if (!name) return false;
      var hit = false;
      $$('.chips input').forEach(function (i) {
        if ((i.getAttribute('data-service') || '').toLowerCase() === name.toLowerCase()) { i.checked = true; hit = true; }
      });
      return hit;
    }
    var m = /[?&]service=([^&]+)/.exec(location.search);
    if (m) pick(decodeURIComponent(m[1].replace(/\+/g, ' ')));
    $$('[data-quote]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var hit = pick(a.getAttribute('data-quote'));
        var target = $('#contact');
        if (hit && target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth' });
          var n = $('input[name="contact[name]"]'); if (n) setTimeout(function () { n.focus({ preventScroll: true }); }, 600);
        }
      });
    });
    $$('form[action*="contact"]').forEach(function (f) {
      f.addEventListener('submit', function () {
        var b = $('button[type=submit]', f); if (b) { b.classList.add('loading'); b.textContent = 'Sending…'; }
      });
    });
    if (location.hash === '#contact_form') { var t = $('#contact'); if (t) t.scrollIntoView(); }
  }

  ready(function () {
    scrollFx(); drawer(); reveal(); hero(); tilt(); gallery(); beforeAfter(); lights(); contact();
  });
})();
